module.exports = __webpack_public_path__ + "9130aaf3b979a9bb25afcbd62f960e6f.svg";